import React from "react";
import "../Common/Bubbles.css";
import { motion, useScroll, useTransform } from "framer-motion";
export default function Bubbles() {
  const { scrollYProgress } = useScroll();
  console.log(scrollYProgress);
  function useParallax(value, distance) {
    return useTransform(value, [0, 1], [-distance, distance]);
  }
  const y1 = useParallax(scrollYProgress, 100);
  const y2 = useParallax(scrollYProgress, 150);
  const y3 = useParallax(scrollYProgress, 220);
  const y4 = useParallax(scrollYProgress, 280);
  const y5 = useParallax(scrollYProgress, -50);
  return (
    <motion.div className="wrapper">
      <motion.div
        style={{ y: y3 }}
        className="drop"
        variants={{
          float: {
            x: [0, 8, -4, 0], // Horizontal movement
            // y: [3 * y, -10, 10, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        <p>SPOTLESS</p>
      </motion.div>
      <motion.div
        style={{ y: y2 }}
        className="drop"
        variants={{
          float: {
            x: [0, 8, -4, 0], // Horizontal movement
            // y: [0, -10, 10, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        <p>State-of-the-art </p>
        <p>machines</p>
      </motion.div>

      <motion.div
        style={{ y: y1 }}
        className="drop"
        variants={{
          float: {
            x: [1, 5, -2, 7], // Horizontal movement
            // y: [0, 3, 2, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        <p>Well-cared</p>
      </motion.div>
      <motion.div
        className="drop"
        style={{ y: y4 }}
        variants={{
          float: {
            x: [0, 8, -4, 0], // Horizontal movement
            // y: [1, 3, 10, 7], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        <p>Fresh</p>
      </motion.div>
      <motion.div
        className="drop"
        style={{ y: y5, paddingLeft: "20px" }}
        variants={{
          float: {
            x: [0, 9, 1, 0], // Horizontal movement
            // y: [0, -5, 2, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        <p>Eco friendly </p>
        <p>Detergents</p>
      </motion.div>
      {/* <motion.div
        className="drop"
        variants={{
          float: {
            x: [5, 6, -1, 4], // Horizontal movement
            y: [2, -3, 3, 6], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        3
      </motion.div> */}
      {/* <motion.div
        className="drop"
        variants={{
          float: {
            x: [9, 2, -8, -7], // Horizontal movement
            y: [-1, 4, -10, 7], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        4
      </motion.div> */}
      {/* <motion.div
        className="drop"
        variants={{
          float: {
            x: [0, 6, -7, 0], // Horizontal movement
            y: [0, -9, 4, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        5
      </motion.div> */}
      {/* <motion.div
        className="drop"
        variants={{
          float: {
            x: [0, 2, 9, 0], // Horizontal movement
            y: [0, 5, -5, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        8
      </motion.div> */}
      {/* <motion.div
        className="drop"
        variants={{
          float: {
            x: [0, 8, -4, 0], // Horizontal movement
            y: [0, -10, 10, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      >
        10
      </motion.div> */}
      {/* <motion.div
        className="drop"
        variants={{
          float: {
            x: [0, 25, -25, 0], // Horizontal movement
            y: [0, -25, 25, 0], // Vertical movement
            transition: {
              duration: 3, // Total duration of the animation
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "mirror", // Move back and forth
            },
          },
        }}
        animate="float"
      ></motion.div> */}
    </motion.div>
  );
}
